import { HQ_APEX } from './detect';

export function hqUrl(path: string): string {
  const dest = path.startsWith('/') ? path : `/${path}`;
  return `https://${HQ_APEX}${dest === '/' ? '/' : dest}`;
}

export function harborUrl(path: string): string {
  const dest = path.startsWith('/') ? path : `/${path}`;
  const params = new URLSearchParams({
    utm_source: HQ_APEX,
    utm_medium: 'hq',
  });
  return `https://harborcoparent.com${dest}?${params.toString()}`;
}

export function satelliteUrl(apex: string): string {
  const params = new URLSearchParams({
    utm_source: HQ_APEX,
    utm_medium: 'hq',
  });
  return `https://${apex}/?${params.toString()}`;
}

export function hqFromSatelliteUrl(sourceApex: string): string {
  const params = new URLSearchParams({
    utm_source: sourceApex,
    utm_medium: 'satellite',
  });
  return `https://${HQ_APEX}/?${params.toString()}`;
}
